import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { FormHeader, Navigator, SectionHeader } from "../../../components";
import { GetIconByName } from "../../../config/icon";
import { getLanguage } from "../../../utils/environment";
import ContactForm from "../../templates/contactForm";
import Footer from "../../footer/index";

const ContactUs = (props) => {
  const len = getLanguage();

  return (
    <>
      <div className="container">
        <Navigator
          data={{ size: "lg", icon: "arrow-left", title: "Contact us" }}
          onClickBack={() => {
            props.history.push("/");
          }}
        />
        <div className={"contact-us-wrapper"}>
          <div className={"cuw__top"}>
            <FormHeader
              data={{
                size: "lg x",
                mainLayerStyles: "mb-4 pb-2",
                formHeader: "Get in Touch with Our Team",
              }}
            />
            <SectionHeader
              data={{
                size: "md x",
                title:
                 "Have a story the world needs to know? Whether you’re a reader, journalist, PR representative, or someone with valuable insight—we welcome your contributions.\n Submit news tips, press releases, Documentary, Storeys, motivation or media inquiries directly to our editorial team at contact@hopeofanewera.org.\n" +
                    "\n" +
                    "Our newsroom reviews all submissions promptly. While we can’t guarantee coverage of every story, we value your input and appreciate your effort in keeping us informed.",
              }}
            />
          </div>
          <div className={"cuw__body"}>
            <div className={"cuwb__details"}>
              <div className={"cuwbd__call"}>
                <div className={"cuwbdc__title"}>Call us</div>
                <div className={"cuwbdc__content"}>
                  Call out team monday to friday 8.00am to 5.00 pm
                </div>
                <div className={"cuwbdc__contact"}>
                  {GetIconByName("phone")}
                  <span>+94 112 170 377</span>
                </div>
                <div className={"cuwbdc__contact "}>
                  {GetIconByName("email")}
                  <span>contact@hopeofanewera.org</span>
                </div>
              </div>
              <div className={"cuwbd__follow"}>
                <div className={"cuwbdf__title"}>
                  Following use on social media
                </div>
                <div className={"cuwbdf__content"}>
                  Call out team monday to friday 8.00am to 5.00 pm
                </div>
                <div className={"cuwbdf__social"}>
                  <div className={"cuwbdfs__logo"}>
                    <a
                        href="https://www.facebook.com/profile.php?id=61563414671127"
                        target="_blank"
                        className="cuwbdfs__l-icon"
                    >
                      {GetIconByName("facebook")}
                    </a>
                  </div>
                  {/*<div className={"cuwbdfs__logo"}>*/}
                  {/*  <a*/}
                  {/*    href="https://www.tiktok.com/@creditcardoffers.lk?is_from_webapp=1&sender_device=pc"*/}
                  {/*    target="_blank"*/}
                  {/*    className="cuwbdfs__l-icon"*/}
                  {/*  >*/}
                  {/*    {GetIconByName("whatsapp")}*/}
                  {/*  </a>*/}
                  {/*</div>*/}
                  {/*<div className={"cuwbdfs__logo"}>*/}
                  {/*  <a*/}
                  {/*    href="https://www.instagram.com/HopeNewEra.lk/"*/}
                  {/*    target="_blank"*/}
                  {/*    className="cuwbdfs__l-icon"*/}
                  {/*  >*/}
                  {/*    {GetIconByName("instagram")}*/}
                  {/*  </a>*/}
                  {/*</div>*/}
                  <div className={"cuwbdfs__logo"}>
                    <a
                      href="https://www.youtube.com/@neweraofhope-n8r"
                      target="_blank"
                      className="cuwbdfs__l-icon"
                    >
                      {GetIconByName("youtube")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default withRouter(ContactUs);
